import React, { useState, useRef } from 'react';

// Added setIsAccepted as a prop to communicate back to SignUpFront
const TOSpopup = ({ title = "Terms of Service", setIsAccepted, children }) => {
  const [isBottomed, setIsBottomed] = useState(false);
  const [isOpen, setIsOpen] = useState(false); 
  const scrollRef = useRef(null);

  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      // Precision check to ensure they hit the bottom
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        setIsBottomed(true);
      }
    }
  };

  const handleFinalAccept = () => {
    if (isBottomed) {
      setIsAccepted(true); // Checks the box in the parent
      setIsOpen(false);    // Closes the modal
    }
  };

  if (!isOpen) {
    return (
      <span 
        onClick={() => setIsOpen(true)} 
        style={{ color: '#4A8EB3', cursor: 'pointer', textDecoration: 'underline' }}
      >
        Terms of Use
      </span>
    );
  }

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex',
      justifyContent: 'center', alignItems: 'center', zIndex: 3000
    }}>
      <div style={{
        position: 'relative',
        width: '90%', maxWidth: '500px', backgroundColor: 'white',
        padding: '30px', borderRadius: '20px', textAlign: 'left'
      }}>
        {/* Close (X): returns to the Create Your Account form without changing the
            checkbox — a prior acceptance stays checked. */}
        <button
          type="button"
          aria-label="Close"
          onClick={() => setIsOpen(false)}
          style={{
            position: 'absolute', top: '14px', right: '16px',
            background: 'none', border: 'none', cursor: 'pointer',
            fontSize: '24px', lineHeight: 1, color: '#2B4B6F', padding: 0
          }}
        >
          &times;
        </button>
        <h2 style={{ fontFamily: 'Judson, serif', marginTop: 0 }}>{title}</h2>
        
        <div 
          ref={scrollRef} 
          onScroll={handleScroll}
          style={{
            height: '250px', overflowY: 'auto', border: '1px solid #ddd',
            padding: '15px', borderRadius: '10px', fontSize: '14px', lineHeight: '1.6'
          }}
        >
          {children}
          <div style={{ textAlign: 'center', padding: '10px', fontWeight: 'bold' }}>--- END OF DOCUMENT ---</div>
        </div>

        <button 
          onClick={handleFinalAccept}
          disabled={!isBottomed}
          style={{
            width: '100%', marginTop: '20px', padding: '12px',
            backgroundColor: isBottomed ? '#4A8EB3' : '#ccc',
            color: 'white', border: 'none', borderRadius: '10px',
            cursor: isBottomed ? 'pointer' : 'not-allowed'
          }}
        >
          {isBottomed ? "I Understand and Accept" : "Scroll to Bottom to Accept"}
        </button>
      </div>
    </div>
  );
};

export default TOSpopup;